/**
 * @fileoverview CSS module for typography styles and text formatting
 * @example
 * // Usage in a component:
 * import styles from './Typography.module.css'
 *
 * function Component() {
 *   return (
 *     <div>
 *       <p className={styles.text}>Regular text</p>
 *       <p className={styles.caption}>Caption text</p>
 *       <a className={styles.link}>Link text</a>
 *       <p className={styles.comment}>Comment text</p>
 *       <strong>Bold text</strong>
 *     </div>
 *   )
 * }
 */


.text {
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: -0.017em;
    color: var(--neutural900);
    font-family: Inter, sans-serif;
}

.text p {
    padding: 0;
    margin: 0;
}

.caption {
    color: var(--neutural900);
}

.list {
    margin: 0;
    padding: 0;
    padding-left: 1.5rem;
}

.link {
    color: var(--indigo700);
    text-underline-offset: 3px;
}

.bold,
strong {
    font-weight: 400;
}

.comment {
    font-weight: 300;
    color: var(--neutural500);
}
